import { DIRECT_DEBIT_CALCULATOR } from '@/src/constants/analytics';
import { GraphType } from '@/src/pages/Payments/DirectDebitCalculator/constants';
import { Col, Radio } from '@ovotech/nebula';
import React from 'react';
import { areContractsVariable } from '@/src/utils/contracts';

import { useSupplyPointsQuery } from '@/src/api/kapi/use-supply-points-query';
import { getEpochDaysDate } from '@/src/utils/date';
import { ContractsResponse } from '@/src/types/Response';
import { StyledRadioField } from './SettingsPanelRadio.styled';

type DirectDebitCalculatorChartRadioProps = {
  newDirectDebitAmount: string;
  contracts: ContractsResponse;
  selectedGraphType: GraphType;
  handleGraphTypeChange: (value: GraphType) => void;
};

export const DirectDebitCalculatorChartRadio = ({
  contracts,
  newDirectDebitAmount,
  selectedGraphType,
  handleGraphTypeChange,
}: DirectDebitCalculatorChartRadioProps) => {
  const supplyPointsQueryResult = useSupplyPointsQuery();

  if (supplyPointsQueryResult.isLoading) {
    return null;
  }
  if (supplyPointsQueryResult.isError || !supplyPointsQueryResult.data) {
    return null;
  }

  const activeOrFutureContracts = contracts.electricity
    .concat(contracts.gas)
    .filter(
      c =>
        c.expiryDate == null ||
        getEpochDaysDate(c.expiryDate).getTime() > Date.now(),
    );

  if (activeOrFutureContracts.length === 0) {
    return null;
  }

  const isVariable = areContractsVariable(contracts);

  const maxExpiryDate = activeOrFutureContracts.sort(
    (a, b) => b.expiryDate! - a.expiryDate!,
  )[0].expiryDate!;

  const analyticsProps = JSON.stringify(
    isVariable
      ? { newDirectDebit: newDirectDebitAmount, isVariable }
      : {
          contractExpiry: getEpochDaysDate(maxExpiryDate),
          newDirectDebit: newDirectDebitAmount,
          isVariable,
        },
  );

  return (
    <Col large={12} medium={12} small={6}>
      <StyledRadioField
        name="graphType"
        label="Compare:"
        defaultValue={selectedGraphType}
        // @ts-ignore it accepts only string | undefined
        onValueChange={handleGraphTypeChange}
      >
        <Radio
          id={GraphType.MONTHLY_END_BALANCE}
          label="Balance"
          value={GraphType.MONTHLY_END_BALANCE}
          data-event-name={DIRECT_DEBIT_CALCULATOR.MONTHLY_SHOW_BALANCE_RADIO}
          data-event-props={analyticsProps}
        />
        <Radio
          id={GraphType.MONTHLY_ESTIMATED_COST}
          label="Cost"
          value={GraphType.MONTHLY_ESTIMATED_COST}
          data-event-name={DIRECT_DEBIT_CALCULATOR.MONTHLY_SHOW_COST_RADIO}
          data-event-props={analyticsProps}
        />
      </StyledRadioField>
    </Col>
  );
};
